export const TeamWizzardPaths = Object.freeze({
  addTeam: 0,
  addCompany: 1,
  addTeamMember: 2,
  moveTeamMember: 3,
  addNewUser: 4,
});

export function isValid(type) {
  return Object.values(TeamWizzardPaths).indexOf(type) >= 0;
}
